<div>
    <div>

        @if (isEmpty) {
        <div class="empty-state text-center py-5">
            <fa-duotone-icon icon="envelope-open-text" size="3x" secondaryOpacity="0.4" class="text-secondary mb-3" />
            @if (viewLocation() === SentEmailListViewLocations.MemberProfilePage) {
                <h5 class="empty-title">{{ SentEmailsMessagingConstants.MEMBER_COMMUNICATION_HISTORY_EMPTY_MESSAGE() }}</h5>
            } @else {
                <h5 class="empty-title">{{ SentEmailsMessagingConstants.SENT_EMAILS_EMPTY_TITLE() }}</h5>
                <p class="text-secondary mb-0">{{ SentEmailsMessagingConstants.SENT_EMAILS_EMPTY_HELP() }}</p>
            }
        </div>
        } @else {

        <div class="d-flex justify-content-between align-items-center">
            <div class="mb-0 text-start flex-grow-0" #jumpToElementMobile>
                Showing: {{sentEmails().length}} of {{totalCount | number}}
            </div>
        </div>

        <!-- Table Start -->
        <div class="table-responsive d-none d-sm-block">
            <table msResponsiveTable class="table table-hover fixed-header placeholder-glow">
                <thead #jumpToElement>
                    <tr>
                        @if (viewLocation() !== SentEmailListViewLocations.MemberProfilePage) {
                        <th msResponsiveTableColumn="recipient" [priority]="1" scope="col" class="sortable"
                            (click)="toggleSortDirection('Recipient')">
                            Recipient
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == SentEmailSortOptions.RecipientAsc ? '0.9' : '0.3'"
                                [secondaryOpacity]="orderBy == SentEmailSortOptions.RecipientDesc ? '0.9' : '0.3'" />
                        </th>
                        }
                        <th msResponsiveTableColumn="subject" [priority]="2" scope="col" class="sortable"
                            (click)="toggleSortDirection('Subject')">
                            Subject
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == SentEmailSortOptions.SubjectAsc ? '0.9' : '0.3'"
                                [secondaryOpacity]="orderBy == SentEmailSortOptions.SubjectDesc ? '0.9' : '0.3'" />
                        </th>
                        <th msResponsiveTableColumn="emailType" [priority]="4" scope="col" class="sortable"
                            (click)="toggleSortDirection('Type')">
                            Type
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == SentEmailSortOptions.EmailTypeAsc ? '0.9' : '0.3'"
                                [secondaryOpacity]="orderBy == SentEmailSortOptions.EmailTypeDesc ? '0.9' : '0.3'" />
                        </th>
                        <th msResponsiveTableColumn="sentAt" [priority]="3" scope="col" class="sortable"
                            (click)="toggleSortDirection('Sent')">
                            Sent
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == SentEmailSortOptions.SentAtAsc ? '0.9' : '0.3'"
                                [secondaryOpacity]="orderBy == SentEmailSortOptions.SentAtDesc ? '0.9' : '0.3'" />
                        </th>
                        <th msResponsiveTableColumn="status" [priority]="1" scope="col" class="sortable"
                            (click)="toggleSortDirection('Status')">
                            Status
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == SentEmailSortOptions.StatusAsc ? '0.9' : '0.3'"
                                [secondaryOpacity]="orderBy == SentEmailSortOptions.StatusDesc ? '0.9' : '0.3'" />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    @for (sentEmail of displaySentEmails; let i = $index; track sentEmail.id) {
                    <tr class="align-middle" [class.even]="i % 2 === 0" [class.odd]="i % 2 !== 0">
                        @if (viewLocation() !== SentEmailListViewLocations.MemberProfilePage) {
                        <td msResponsiveTableColumn="recipient" [priority]="1">
                            <span class="recipient-cell" [class.placeholder]="isLoading"
                                [msTooltip]="sentEmail.recipientEmailAddress ?? ''" msTooltipOnlyIfTruncated>
                                {{ sentEmail.recipientEmailAddress | noValue }}
                            </span>
                        </td>
                        }
                        <td msResponsiveTableColumn="subject" [priority]="2">
                            <span class="subject-cell" [class.placeholder]="isLoading"
                                [msTooltip]="sentEmail.subject ?? ''" msTooltipOnlyIfTruncated>
                                {{ sentEmail.subject | noValue }}
                            </span>
                        </td>
                        <td msResponsiveTableColumn="emailType" [priority]="4">
                            <span [class.placeholder]="isLoading">{{ sentEmail.emailType | formatLabel }}</span>
                        </td>
                        <td msResponsiveTableColumn="sentAt" [priority]="3">
                            <span [class.placeholder]="isLoading">{{ sentEmail.sentAt | orgDate: 'medium' | noValue }}</span>
                        </td>
                        <td msResponsiveTableColumn="status" [priority]="1">
                            <ms-status-badge [status]="sentEmail.status" [(isLoading)]="isLoading" />
                        </td>
                    </tr>
                    }
                </tbody>
                <tfoot class="overflow-auto" ms-pagination [take]="take" (loadMoreInView)="loadMoreInView()"
                    [(skip)]="skip" [hasNext]="hasNext" [itemCount]="displaySentEmails.length"
                    (jumpToClicked)="jumpToTop($event)">
                </tfoot>
            </table>
        </div>
        <!-- Table End -->

        <!-- Mobile Cards Start -->
        <div id="mobileTableCards" class="d-block d-sm-none">
            @for (sentEmail of displaySentEmails; let i = $index; track sentEmail.id) {
            <div class="card d-flex pt-1 d-inline d-sm-none my-3">
                <div class="d-flex flex-column card-body">
                    <div class="d-flex flex-row align-items-start">
                        <div class="right-card-column w-100">
                            <h5 class="card-title mb-1 d-flex align-items-center min-width-0"
                                [class.placeholder]="isLoading">
                                <span class="text-truncate" [msTooltip]="sentEmail.subject ?? ''" msTooltipOnlyIfTruncated>
                                    {{ sentEmail.subject | noValue }}
                                </span>
                            </h5>

                            @if (viewLocation() !== SentEmailListViewLocations.MemberProfilePage) {
                            <div class="card-text text-muted mb-2 text-truncate" [class.placeholder]="isLoading"
                                [msTooltip]="sentEmail.recipientEmailAddress ?? ''" msTooltipOnlyIfTruncated>
                                {{ sentEmail.recipientEmailAddress | noValue }}
                            </div>
                            }
                        </div>
                        <div class="text-end ms-2">
                            <ms-status-badge [status]="sentEmail.status" [(isLoading)]="isLoading" />
                        </div>
                    </div>

                    <div class="row g-2">
                        <div class="col-6 card-text" [class.placeholder]="isLoading">
                            <div class="fw-semibold">Type</div>
                            {{ sentEmail.emailType | formatLabel }}
                        </div>
                        <div class="col-6 card-text" [class.placeholder]="isLoading">
                            <div class="fw-semibold">Sent</div>
                            {{ sentEmail.sentAt | orgDate: 'medium' | noValue }}
                        </div>
                    </div>
                </div>
            </div>
            }
            <div ms-in-view-port (inViewPort)="loadMoreInView()" ms-pagination [take]="take" [(skip)]="skip"
                [hasNext]="hasNext" [itemCount]="displaySentEmails.length" (jumpToClicked)="jumpToTop($event)">
            </div>
        </div>
        <!-- Mobile Cards End -->

        }
    </div>
</div>
